var map = {
	"./arkea.png": "./src/assets/static/images/logo/bank/square/arkea.png",
	"./banque_pop.jpg": "./src/assets/static/images/logo/bank/square/banque_pop.jpg",
	"./banque_postale.png": "./src/assets/static/images/logo/bank/square/banque_postale.png",
	"./bnp.png": "./src/assets/static/images/logo/bank/square/bnp.png",
	"./boursorama.png": "./src/assets/static/images/logo/bank/square/boursorama.png",
	"./ca.png": "./src/assets/static/images/logo/bank/square/ca.png",
	"./caisse_epargne.png": "./src/assets/static/images/logo/bank/square/caisse_epargne.png",
	"./cic.jpg": "./src/assets/static/images/logo/bank/square/cic.jpg",
	"./credit_mutuel.jpg": "./src/assets/static/images/logo/bank/square/credit_mutuel.jpg",
	"./hellobank.png": "./src/assets/static/images/logo/bank/square/hellobank.png",
	"./lcl.png": "./src/assets/static/images/logo/bank/square/lcl.png",
	"./other.png": "./src/assets/static/images/logo/bank/square/other.png",
	"./soge.png": "./src/assets/static/images/logo/bank/square/soge.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/static/images/logo/bank/square sync recursive ^\\.\\/.*$";